import { render, staticRenderFns } from "./CDLastCommitCard.vue?vue&type=template&id=5baab24b&scoped=true"
import script from "./CDLastCommitCard.vue?vue&type=script&lang=ts"
export * from "./CDLastCommitCard.vue?vue&type=script&lang=ts"
import style0 from "./CDLastCommitCard.vue?vue&type=style&index=0&id=5baab24b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baab24b",
  null
  
)

export default component.exports